import { createFileRoute } from '@tanstack/react-router';
import EmployeesCreateModule from '@/modules/employees/employees/EmployeesCreateModule';

export const Route = createFileRoute('/(dashboard)/_dashboard/hr/employee-edit/$id')({
  component: EmployeesCreateModule,
});
